<script type="text/javascript">
  // Cards: Stories that sell
  export default {
    props: ['website'],
    data() {
      return {
        title: 'REVINRE',


      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="0"
    ></w-site-navbar>
    <main>

      <section class="bg-home pb-5">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-15 pb-10 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="home-title mb-3 text-white" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-white home-desc"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a href="/selling" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init">I'm selling</a></div>
                    <div class="col-sm px-sm-1"><a href="/buying" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                    <div class="col-sm px-sm-1"><a href="/valuation" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">“Stories that Sell” recipe:</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s navigation menu, sub menu's and additional pages.</p>
          </div>

          <div class="border font-weight-bold rounded bg-lighten-success small p-5">
            <ul class="pl-3">
              <li>
                <h3>Audience Profile:</h3>
                <ul class="pl-5">
                  <li>
                    What is our current audience?
                    <ul class="pl-5 text-blue">
                      <li>Our current audience is generally referrals and repeat clients.</li>
                    </ul>
                  </li>
                  <li>
                    What do we want our audience to be?
                    <ul class="pl-5 text-blue">
                      <li>
                        Everyone potentially. While we do want to target everyone, having material specific to each group of potential home sellers/buyers to help explain our process and how it works for each group will be helpful.
                        <ul class="pl-5">
                          <li>Material: Pamphlets, website landing pages.</li>
                          <li>Groups: First time sellers/buyers, Investors/Flippers, Builders, FSBO, Estate, Corporate.</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    What is the problem we are here to solve for our audience?
                    <ul class="pl-5 text-blue">
                      <li>Bringing the process of buying and selling a home into today's technology driven world.</li>
                      <li>Simplifying the home buying and selling process while giving the consumer more control.</li>
                    </ul>
                  </li>
                  <li>
                    What are the positives we can present to our audience that would make them view our solution in a good light?
                    <ul class="pl-5 text-blue">
                      <li></li>
                    </ul>
                  </li>
                  <li>
                    What are the negatives or fears our audience may have about our solution or the real estate market in general.
                    <ul class="pl-5 text-blue">
                      <li>An agent is required because the process is confusing and carries a lot of risks financially and legally.</li>
                      <li>Unsure what the list price should be and unsure of how to get a home valuation. Also does not trust automated home valuations.</li>
                      <li>Afraid to commit to the REVINRE solutions with an upfront cost when the process is not fully understood. This is not an issue with repeat clients because they understand the process as well as what the services are.</li>
                    </ul>
                  </li>
                  <li>
                    What does our current audience already say about our solution?
                    <ul class="pl-5 text-blue">
                      <li>Overall great things. We need to use this in a more effective way to assure trust with our future audience.</li>
                    </ul>
                  </li>
                  <li>
                    Will telling a story about a past client's journey with us help us connect to the audience?
                    <ul class="pl-5 text-blue">
                      <li>Yes definitely. As long as we can get a clear story and get it in front of the audience effectively.</li>
                    </ul>
                  </li>
                  <li>
                    Who should be the one telling the story? REVINRE staff or past clients?
                    <ul class="pl-5 text-blue">
                      <li>I believe both are important.</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h3>Simple Sales stories:</h3>
                <ul class="pl-5">
                  <li></li>
                </ul>
              </li>
              <li>
                <h3>Social proof:</h3>
                <ul class="pl-5">
                  <li></li>
                </ul>
              </li>
              <li>
                <h3>Rags to Riches:</h3>
                <ul class="pl-5">
                  <li>
                    Hidden value:
                    <ul class="pl-5 text-blue">
                      <li>REVINRE's hidden value is very real. We offer extreme savings as well as a simplified process for selling a home.</li>
                    </ul>
                  </li>
                  <li>
                    Trigger and Struggle:
                    <ul class="pl-5 text-blue">
                      <li>The world has an overwhelming presence of real estate options to choose from, most of which are out to take as much money out of people's pockets as possible. Because of this it is very hard to get the word out about true worthwhile options in the real estate world such as REVINRE. It is also hard for people to trust anything related to real estate.</li>
                    </ul>
                  </li>
                  <li>
                    Deserved Recognition
                    <ul class="pl-5 text-blue">
                      <li>To achieve recognition we need to find a way to bring people in to hear our story and then present our story clearly.</li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <h3>Pitch Perfect:</h3>
                <ul class="pl-5">
                  <li>
                    Basic Pitch:
                    <ul class="pl-5">
                      <li>
                        What's the problem you're solving for me?
                        <ul class="pl-5 text-blue">
                          <li>Simplifying the home selling process.</li>
                          <li>Saving money.</li>
                        </ul>
                      </li>
                      <li>
                        How do you solve it?
                        <ul class="pl-5 text-blue">
                          <li>Online platform to walk the client through the home selling process.</li>
                          <li>Only charging for services the client would like rather than a broad overpriced commission.</li>
                        </ul>
                      </li>
                      <li>
                        Why should I trust you?
                        <ul class="pl-5 text-blue">
                          <li>Past client testimonials.</li>
                          <li>Referrals.</li>
                          <li>Clean explanations of our solution.</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li>
                    P.O.P.P.:
                    <ul class="pl-5">
                      <li>
                        Problem (what needs fixing right now (negative)):
                        <ul class="pl-5 text-blue">
                          <li>Need to sell my home in a simple way and save as much money as possible.</li>
                        </ul>
                      </li>
                      <li>
                        Opportunity (also available to us now (positive)):
                        <ul class="pl-5 text-blue">
                          <li></li>
                        </ul>
                      </li>
                      <li>
                        Practical Steps (if we do this, it won't be easy (negative)):
                        <ul class="pl-5 text-blue">
                          <li></li>
                        </ul>
                      </li>
                      <li>
                        Promise (but if we get it right, it will be great (positive)):
                        <ul class="pl-5 text-blue">
                          <li></li>
                        </ul>
                      </li>
                    </ul>
                  </li><li>
                    Outcome:
                    <ul class="pl-5">
                      <li></li>
                    </ul>
                  </li>
                </ul>
              </li>

            </ul>
          </div>

        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">Our Story Plan:</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s navigation menu, sub menu's and additional pages.</p>
          </div>

          <div class="border font-weight-bold rounded bg-lighten-success small p-5">
            <ul class="pl-3">
              <li>
                <h4>Define our process and solution for each group of home sellers/buyers in a simple direct way.</h4>
                <ul class="pl-5 mb-3 text-blue">
                  <li>Create verbiage which can be used between web pages, pamphlets, emails/newsletters etc.</li>
                  <li>Integrate keywords and SEO relevant to the audience we want to attract into the verbiage.</li>
                </ul>
              </li>
              <li>
                <h4>Simplify the listing and buying process on the website.</h4>
                <ul class="pl-5 mb-3 text-blue">
                  <li>This is in the works with the version 5.0 update but of course additional planning is always helpful.</li>
                </ul>
              </li>
              <li>
                <h4>Create a plan for SEO and SEM.</h4>
                <ul class="pl-5 mb-3 text-blue">
                  <li>Research SEO keywords and content.</li>
                  <li>Monitor SEO statistics and traffic and adjust accordingly to improve traffic as well as visitor session duration.</li>
                </ul>
              </li>
            </ul>
          </div>

        </div>
      </section>

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
